import { render, staticRenderFns } from "./PersonalAccount.vue?vue&type=template&id=7c69e86e&scoped=true&lang=pug&"
import script from "./PersonalAccount.vue?vue&type=script&lang=js&"
export * from "./PersonalAccount.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAccount.vue?vue&type=style&index=0&id=7c69e86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c69e86e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
